import { Assignment } from "@hydrologiq/gql/graphql"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type RunDryContext = {
  days: number | undefined
  timestamp: number
}

interface ForecastState {
  runDry: Record<string, RunDryContext>
}

const initialState = { runDry: {} } satisfies ForecastState as ForecastState

export const forecastSlice = createSlice({
  name: "forecast",
  initialState,
  selectors: {
    getRunDry: (state): Record<string, RunDryContext> => {
      return state.runDry
    },
    getNextRunDry: (state, activeAssignments: Assignment[]): [string | undefined, RunDryContext | undefined] => {
      const result = Object.entries(state.runDry)
        .filter(([assignment, runDry]) => runDry.days && activeAssignments.some((a) => a.id === assignment))
        .sort((a, b) => a[1].days! - b[1].days!)[0]
      if (!result) return [undefined, undefined]

      return [result[0], result[1]]
    },
    getSingleRunDry: (state, assignment?: string): RunDryContext | undefined => {
      return assignment ? state.runDry[assignment] : undefined
    },
  },
  reducers: {
    setRunDry: (state, action: PayloadAction<[string, RunDryContext]>) => {
      state.runDry[action.payload[0]] = action.payload[1]
    },
  },
})

export const { setRunDry } = forecastSlice.actions
export const { getRunDry, getSingleRunDry, getNextRunDry } = forecastSlice.selectors
export default forecastSlice.reducer
